// Split out from api.ts so sentry.ts can import ApiError without an import
// cycle (api.ts imports captureApiFailure from sentry.ts).
export class ApiError extends Error {
  constructor(
    readonly status: number,
    readonly detail: string,
  ) {
    super(detail);
    this.name = "ApiError";
  }
}
